// extracted by mini-css-extract-plugin
export default {"wrapper":"IqosSuperBrand_wrapper__51KNx","iconList":"IqosSuperBrand_iconList__zdf-y","white":"IqosSuperBrand_white__xO1Qt"};